import { cn } from '@playerbase/ui';

import { BuildMarkerLabel } from '../games/build-marker-label.js';
import type { BuildMarkerSummary } from '../games/build-timeline.js';

interface Props {
  marker: BuildMarkerSummary;
  // Pulsed when the user clicks the matching activity-feed entry.
  highlighted?: boolean;
  innerRef?: ((el: HTMLDivElement | null) => void) | undefined;
}

// Full-width divider marking the point in a feed where a build went live.
// Interleaved between message / poll / submission rows at the build's
// chronological position so studios can see which build a run of feedback
// landed against. Centred rule + "Build changed" label, visually distinct
// from the content rows it sits between.
export function BuildChangedRow({ marker, highlighted = false, innerRef }: Props): JSX.Element {
  return (
    <div
      ref={innerRef}
      className={cn(
        'flex items-center gap-3 px-4 py-2 transition-colors',
        highlighted && 'bg-info-bg ring-2 ring-info ring-inset',
      )}
    >
      <span className="h-px flex-1 bg-border" aria-hidden />
      <span className="flex flex-wrap items-center justify-center gap-2 text-xs text-text-muted">
        <span className="font-mono text-[10px] font-semibold uppercase tracking-wider">
          Build changed
        </span>
        <BuildMarkerLabel marker={marker} />
      </span>
      <span className="h-px flex-1 bg-border" aria-hidden />
    </div>
  );
}
